import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { fetchBonus } from 'core/actions/bonus';
import Tier from './components/Tier';

import {
  selectBonusTiersConfig,
  selectBonusTiersIsLoading,
  selectBonusTiersIsLoaded,
  selectBonusTiersPlacement,
} from './selectors';

import './BonusTiers.scss';

function BonusTiers({
  bonusTiersRef,
}) {
  const config = useSelector(selectBonusTiersConfig);
  const isLoading = useSelector(selectBonusTiersIsLoading);
  const isLoaded = useSelector(selectBonusTiersIsLoaded);
  const tiers = useSelector(selectBonusTiersPlacement);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoading && !isLoaded) {
      const { api: { params, options } } = config;
      dispatch(fetchBonus(params, options));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isEmpty(tiers) || tiers.length === 1) return null;

  return (

    <div className="mn_bonusTiers" ref={bonusTiersRef} data-test="bonus-tiers">
      <div className="mn_topTiersBorder" />
      {tiers.map((tier, index) => <Tier key={tier.tierId} {...tier} position={index + 1} />)}
    </div>
  );
}

export default BonusTiers;
